export const venueOpenStatus = [
  { code: 0, label: 'closed'},
  { code: 1, label: 'open'},
];